import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  MenuItem,
  Menu,
  Button,
} from "@material-ui/core";
import {
  ArrowDropUp,
  ArrowDropDown,
} from "@material-ui/icons";

import Permissions from "../../permissions";
import { PermissionedDisplay } from "../../components/Layout";

const OtaVehiclesBulkDropdown = ({
    onSelect,
    disabled,
    overMaxFpa,
    overMaxGpa,
  }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outlined"
        disabled={disabled}
      >
        {t("Ota.BulkAction")} {open ? <ArrowDropUp /> : <ArrowDropDown />}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Install Passive Hardware"
          value="Install Passive Hardware"
        >
          {t("Ota.InstallPassiveHardware")}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Poke At Selected"
          value="Poke At Selected"
        >
          {t("Ota.PokeAtSelected")}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Send Geofence Packages"
          value="Send Geofence Packages"
          disabled={overMaxGpa}
        >
          {t("Ota.SendGeofence")}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Send Firmware Packages"
          value="Send Firmware Packages"
          disabled={overMaxFpa}
        >
          {t("Ota.SendFirmware")}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Stop Geofence Packages"
          value="Stop Geofence Packages"
        >
          {t("Ota.StopGeofence")}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onSelect(e);
            setAnchorEl(null);
          }}
          name="Stop Firmware Packages"
          value="Stop Firmware Packages"
        >
          {t("Ota.StopFirmware")}
        </MenuItem>
        <PermissionedDisplay
         permission={[Permissions.writeFleets]}
        >
          <MenuItem
            onClick={(e) => {
              onSelect(e);
              setAnchorEl(null);
            }}
            name="Fleet Transfer"
            value="Fleet Transfer"
          >
            {t("Ota.FleetTransfer")}
          </MenuItem>
        </PermissionedDisplay>
        <PermissionedDisplay
          permission={[Permissions.writeHibernate]}
        >
          <MenuItem
            onClick={(e) => {
              onSelect(e);
              setAnchorEl(null);
            }}
            name="Hibernate Vehicles"
            value="Hibernate Vehicles"
          >
            {t("Ota.HibernateVehicles")}
          </MenuItem>
        </PermissionedDisplay>
      </Menu>
    </>
  );
};

OtaVehiclesBulkDropdown.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  overMaxFpa: PropTypes.bool.isRequired,
  overMaxGpa: PropTypes.bool.isRequired,
};

OtaVehiclesBulkDropdown.defaultProps = {
  disabled: false,
};

export default OtaVehiclesBulkDropdown;
